import clsx from "clsx";

import Card from "../card/Card";

import OutletCardBanner from "./OutletCardBanner";
import styles from "./OutletCard.module.scss";
import OutletCardOutletInfoSummary from "./OutletCardOutletInfoSummary";

interface OutletCardProps {
  outletName: string;
  isOutletOpen?: boolean;
  isOutletSelected?: boolean;
}

export default function OutletCard({
  outletName,
  isOutletOpen = true,
  isOutletSelected = false,
}: OutletCardProps) {
  const showOutletBanner = false;
  const isWhiteLabeled = true;

  return (
    <Card
      style={{
        marginBottom: "5px",
      }}
      className={clsx(styles.container, {
        [styles.selected]: isWhiteLabeled && isOutletSelected,
      })}
      tabIndex={0}
      aria-label={outletName}
    >
      {showOutletBanner && <OutletCardBanner outletName={outletName} />}
      <OutletCardOutletInfoSummary
        outletName="Outlet Name"
        className={styles.outletInfo}
        showOutletStatus
        isOutletOpen={isOutletOpen}
      />
    </Card>
  );
}
